import styled from "styled-components";

// Clear the border radius on the contact number input
export const ContactNumberInputBorder = styled.div`
  #contactNumber {
    border-left-style: hidden !important;
    border-radius: 0px 5px 5px 0px;
  }
`;

// Clear the border radius on the country code input
export const CountryCodeInputBorder = styled.div`
  #countryCode div {
    border-radius: 5px 0px 0px 5px;
  }
`;
